module.exports = __webpack_public_path__ + "img/DE00268.fc579754.png";